<template>
  <div class="popup-wrap" :class="{ active: this.$store.state.app.isNeedCookie && !this.$store.getters.agreeCookie }">
    <div class="cookie-frame">
      <div>
        {{ $t("Bao.cookie_content") }}
      </div>
      <div class="cookie-btn-frame">
        <button type="button" class="btn btn-primary btn-policy" @click="acceptCookie">
          {{ $t("Bao.cookie_accept") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieAgree',
  methods: {
    acceptCookie() {
      this.$store.commit('SET_IS_AGREE_COOKIE', true)
      // Store the preference in a cookie
      document.cookie = 'isAgreeCookie=true; path=/'
    }
  }
}
</script>
